import { notifications } from '@mantine/notifications'
import { IconCheck, IconX, IconAlertCircle } from '@tabler/icons-react'

export const showNotification = {
  success: (message: string, autoClose: number = 2000) => {
    notifications.show({
      message,
      color: 'green',
      icon: <IconCheck size={18} />,
      autoClose,
    })
  },

  error: (message: string, autoClose: number = 2000) => {
    notifications.show({
      message,
      color: 'red',
      icon: <IconX size={18} />,
      autoClose,
    })
  },

  info: (message: string, autoClose: number = 2000) => {
    notifications.show({
      message,
      color: 'blue',
      icon: <IconAlertCircle size={18} />,
      autoClose,
    })
  },
}
